import styles from '../../../styles/LoginHelp.module.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// import { isEmpty } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import { appInsights } from '../../../appInsights/appInsights';

const LoginHelp = () => {

  const navigate = useNavigate();
  const [goto,setGoto] = useState("");


  useEffect(()=>{
    setGoto(new URLSearchParams(window.location.search).get('goto') || '')
    appInsights.trackPageView({name: 'Login Help'});
  },[])

  
  return (
    <>
    {/* back to login and header */}
    <div>
      <div className={styles.headerTop}>
        <div className={styles.headerLogin}></div>
      </div>
      <a className={styles.backToLogin} onClick={() => {
                  // navigate("/resetpassword?goto=" + goto);
                  if (isEmpty(goto)) {
                    navigate("/login");
                  } else {
                    navigate("/login?goto=" + goto);
                  }
                }} >
          <div className={styles.backToLoginArrow} >
            <b>{" <-"}</b>
          </div >
          <div className={styles.backToLogintext} >
            Return to Login
          </div>
      </a>
    </div>
    <div className="banner"  >
          <div className="leftbanner" >{" US and Non-US Persons "}</div >
          <div className="spanCenter">Technical Data<a  style={{textDecoration:'none', color:'#000'}} href="https://rtxusers.sharepoint.us/sites/enghub-PW/_layouts/15/settings.aspx">/</a>Information&nbsp;<strong>Strictly Prohibited</strong></div>
          <div className="rightbanner" >{" US and Non-US Persons "}</div >
    </div>
    <div className={styles.contectDiv}>
      <section className={styles.loginHelpSection}>
        <div className={styles.loginHelpContentSection}>
          <div className={styles.frameLoginHelp1}>
            <p className={styles.sectionHeader}>Login Help</p>
            <p className={styles.sectionSubHeader}>If you are having trouble logging in, please follow the instructions on this page.</p>
          </div>
          <div className={styles.frameLoginHelp2}>
            <p className={styles.rightLoginHelpHeader}><b>Need to change your password?</b></p>
            <p className={styles.rightLoginHelpContent}>If you need to reset your password, you can do so by following the <a href={ process.env.REACT_APP_CHANGE_PW_LINK } rel="noopener noreferrer" onClick={() => {
                  if (isEmpty(goto)) {
                    navigate("/resetpassword");
                  } else {
                    navigate("/resetpassword?goto=" + goto);
                  }
                }}
            >Change Password</a> link.</p>
            <p className={styles.rightLoginHelpHeader}><b>If you are having an issue logging in to the portal:</b></p>
            <ul className={styles.rightLoginHelpList}>
              <li style={{marginBottom:"8px"}}>Please try the <a rel="noopener noreferrer" onClick={() => {
                  if (isEmpty(goto)) {
                    navigate("/resetpassword");
                  } else {
                    navigate("/resetpassword?goto=" + goto);
                  }
                }}>Forgot Password</a> link on the login page. Passwords expire every 90 days.</li>
              <li style={{marginBottom:"8px"}}>If you still cannot log in, please send a <a href="mailto:portalidentity@prattwhitney.com" target="_blank" rel="noopener noreferrer">Login Assist</a> email.</li>
              <li>Note that 12 months of inactivity will require that you re-register.</li>
            </ul>
          </div>
        </div>
      </section>
      <section className={styles.furtherAssistanceSection}>
      <div className={styles.furtherAssistanceContentSection}>
        <div className={styles.frameLoginHelp1}>
          <p className={styles.sectionHeader}>Further Assistance</p>
        </div>
        <div className={styles.frameLoginHelp2}>
          <p className={styles.rightLoginHelpContent} style={{height:"88px !important"}}>For further assistance with EngineWise&reg; Connect Portal, please contact the EngineWise&reg; Connect Portal team at <a href="mailto:gppwolshelpcenter@prattwhitney.com" target="_blank" rel="noopener noreferrer">gppwolshelpcenter@prattwhitney.com</a></p>
        </div>
      </div>
      </section>
      <section className={styles.bookMarkSection}>
        <div className={styles.bookMarkContentSection}>
          <div className={styles.frameLoginHelp1}>
            <p className={styles.sectionHeader}>Bookmarking the Portal</p>
          </div>
          <div className={styles.frameLoginHelp2}>
            <p className={styles.rightLoginHelpContent} style={{height:"44px !important"}}>You can bookmark the portal for faster access by following the steps below:</p>
            <ol className={styles.rightLoginHelpList}>
              <li style={{marginBottom:"8px"}}>Open the browser.</li>
              <li style={{marginBottom:"8px"}}>Type/paste the portal URL into the address bar:<br /><a href="https://connect.prattwhitney.com" target="_blank" rel="noopener noreferrer">https://connect.prattwhitney.com</a></li>
              <li style={{marginBottom:"8px"}}>Log into the portal using your existing credentials (email address and password).</li>
              <li style={{marginBottom:"8px"}}>On the portal home page, click the favorites menu and select "Add to Favorites."</li>
              <li style={{marginBottom:"8px"}}>Log out of the portal and close the browser.</li>
              <li >When you select your new favorites link, you will be navigated to the EngineWise&reg; Connect Portal login page.</li>
            </ol>
          </div>
        </div>
      </section>
    </div>
    </>

  );
};

export default LoginHelp;
